import { NavLink, useParams } from 'react-router';
import {
  LayoutDashboard, UtensilsCrossed, QrCode, CreditCard, Settings,
} from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function MobileNav() {
  const { slug } = useParams();
  const { venues } = useAuth();
  const currentVenue = venues.find(v => v.slug === slug) ?? venues[0] ?? null;

  // Venue-scoped tabs are dropped entirely when there's no venue to scope them to.
  // Pointing them at a bare /venues base would build paths no route matches, and
  // the catch-all would bounce the user home on tap.
  const venueItems = currentVenue
    ? [
        { to: `/venues/${currentVenue.slug}/overview`, label: 'Home', icon: LayoutDashboard },
        { to: `/venues/${currentVenue.slug}/menu`, label: 'Menu', icon: UtensilsCrossed },
        { to: `/venues/${currentVenue.slug}/qr-codes`, label: 'QR Codes', icon: QrCode },
      ]
    : [];

  const items = [
    ...venueItems,
    { to: '/billing', label: 'Plans', icon: CreditCard },
    { to: '/account/settings', label: 'Settings', icon: Settings },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-surface border-t border-border backdrop-blur-xl safe-bottom">
      <div className="flex justify-around items-end px-1 pt-1.5 pb-2">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 min-w-0 px-2 py-1.5 rounded-xl transition-all ${
                isActive
                  ? 'text-orange-500'
                  : 'text-ink-muted'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`w-10 h-8 flex items-center justify-center rounded-lg transition-all ${
                  isActive ? 'bg-orange-500/10' : ''
                }`}>
                  <Icon className="w-5 h-5" />
                </div>
                <span className={`text-[10px] font-semibold leading-none ${
                  isActive ? 'text-orange-500' : 'text-ink-faint'
                }`}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
